import React from "react";

import { Lista, JogoRifa } from "./components";
import { newSession } from "../reducers/usuario/usuarioActions";
import { selectConcursoScreen } from "../reducers/concurso/concursoActions";
import {
  setCart,
  setDisabledNumbers,
  setLoading,
  setGUID,
} from "../reducers/rifa/rifaActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import "./styles/rifa.scss";

import { doRequest } from "../modules/request";
import Ticket from "./components/ticket";
import { getDateTime, getTimestamp } from "./utils/getDateTime";
import { R$ } from "./utils/brl";
import moment from "moment";
import { CONTEST_API } from "../modules/constants";
import PixTicket from "./components/pixticket";
import { enviarAposta } from "../reducers/carrinho/carrinhoActions";
import { emitIntent } from "../newDesign/utils/emitIntent";
import { deleteState, loadState, saveState } from "../modules/localStorage";
import { forceInt } from "../utils/forceInt";

import {
  AnalyticsSetGameType,
  AnalyticsSetFinishPurchase
} from "../reducers/analytics/analyticsActions";

class Rifa extends React.Component {
  constructor(props) {
    super(props);

    const savedSession = window["wweb-session"];

    /**
     * @type {{
     *  selectedGame: {}|null,
     *  session: {[key: string]: any},
     *  ticket: any,
     *  showTicket: boolean
     * }}
     */
    this.state = {
      selectedGame: null,
      session: savedSession,
      ticket: null,
      showTicket: false,
      isPix: false,
      isPreTicket: false,
      ETicket: undefined,
      isFetching: false,
      gameInfo: undefined,
      isBicho: false
    };

    this.sendBet = this.sendBet.bind(this);
    this.sendDueBet = this.sendDueBet.bind(this);
    this.hideTicket = this.hideTicket.bind(this);
    this.transacaoComRepeticao = this.transacaoComRepeticao.bind(this);
    this.transacaoSemRepeticao = this.transacaoSemRepeticao.bind(this);
    this.validateExtractionTime = this.validateExtractionTime.bind(this);
  }

  assignRifaType(TipoRifa_ID) {
    switch (TipoRifa_ID) {
      case 0:
        return "sem-validacao";
      case 1:
        return "sorteio";
      case 2:
        return "com-validacao";
      default:
        return "sem-validacao";
    }
  }

  filterRifasConcluidas(arrRifas, concluidas = false) {
    const dateNow = new Date();
    let rifas = [];

    rifas = [...arrRifas.filter(rifa => {
      let isNotFinished = false;

      rifa.dateOptions.forEach(date => {
        const strDate = date.split(' ')[0];
        const blockTime = rifa.raflleBlockTime;

        const newDate = moment(strDate + " " + blockTime);
        newDate.subtract(5, "minutes")
        
        const calcEndSales = Math.ceil((newDate.valueOf() - dateNow.getTime()) / (1000 * 3600 * 24));
        if (calcEndSales > 0) isNotFinished = true;
      })

      if (isNotFinished && !concluidas) return true;
      if (!isNotFinished && concluidas) return true;
      return false;
    })];

    rifas.sort((a, b) => {
      const calculateDateTime = (rifa) => {
        const date = rifa.dateOptions[0];
        const dateTime = new Date(`${date.split(' ')[0]} ${rifa.raflleBlockTime}`);
        if (!concluidas) {
          dateTime.setMinutes(dateTime.getMinutes() - 5);
        }
        return dateTime;
      };

      const dateTimeA = calculateDateTime(a);
      const dateTimeB = calculateDateTime(b);

      if (dateTimeA > dateTimeB) {
        return !concluidas ? 1 : -1;
      } else if (dateTimeA < dateTimeB) {
        return !concluidas ? -1 : 1;
      } else {
        // Se as datas forem iguais, compare os horários
        const timeA = new Date(`1970-01-01 ${a.raflleBlockTime}`);
        const timeB = new Date(`1970-01-01 ${b.raflleBlockTime}`);
        timeA.setMinutes(timeA.getMinutes() - 5);
        timeB.setMinutes(timeB.getMinutes() - 5);

        if (timeA > timeB) {
          return !concluidas ? 1 : -1;
        } else if (timeA < timeB) {
          return !concluidas ? -1 : 1;
        } else {
          return 0;
        }
      }
    });

    if (!concluidas) {
      rifas.sort((a, b) => {
        if (a.isEmphasis === b.isEmphasis) {
          return 0; // Mantém a ordem atual
        }
        if (a.isEmphasis) {
          return -1; // Move "a" para cima se destaqueWeb for true
        }
        return 1; // Move "b" para cima se destaqueWeb for true
      });
    }

    return rifas;
  }

  gameInfo(session) {
    return (session.objRifas.arrRifas.filter(
      (rifa) =>
        rifa.lstDatas.length > 0 ||
        rifa.sdtSorteio.length > 0 ||
        rifa.vchResultado.trim().length > 0
    ).map((rifa, index) => {
      const extraction = (session.arrExtracoesRifa || []).find(
        (extraction) => extraction.tnyExtracao == rifa.tnyExtracao
      );
      const {
        objTipoJogo: game,
        lstPremioFixo,
        lstPremioExtracao,
      } = session.arrTipoJogo.find(
        (jogo) =>
          {
            const matchTipoJogo = jogo.objTipoJogo && jogo.objTipoJogo.sntTipoJogo == rifa.intTipoJogo;
            return rifa.ModeloRifa_ID === 1 
              ? matchTipoJogo && jogo.objTipoJogo.bitME === 1
              : matchTipoJogo
          }
      ) || { objTipoJogo: {} };
      var dataAtual = new Date();
      var ano = dataAtual.getFullYear();
      var mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0'); // Adiciona 1 ao mês porque os meses começam do zero
      var dia = dataAtual.getDate().toString().padStart(2, '0');
      var dataFormatada = ano + '-' + mes + '-' + dia;
      if(!Object.entries(game).length) return null;
      
      const dateOptions = rifa.lstDatas.length > 0 ? rifa.lstDatas : [rifa.sdtSorteio || dataFormatada];

      const numberAmount = game.tnyUnidade === 2
        ? game.tnyNumeroMax
        : Math.pow(10, game.tnyTamanhoMax || 0);

      const raffleWinners = (rifa.arrGanhador || []).map((winner) => {
        const { VchNome } = winner;

        return {
          name: VchNome || "",
        }
      }).filter((winner) => !!winner.name);

      const numberLength = Math.floor(Math.log10(rifa.numberAmount)) + 1;
      return dateOptions.map(dateOption => {
        const tipo = this.assignRifaType(rifa.TipoRifa_ID);

        return {
          title: rifa.vchTituloWeb || "Rifa sem título",
          tipo,
          description: rifa.vchDescricaoWebItem || "",
          shortDescription: rifa.vchDescricaoWebLista || "",
          numberAmount,
          numberLength,
          image: rifa.vchImagemWebURL || "/assets/rifa.png",
          value: typeof game.numValorCota != "undefined" ? game.numValorCota : typeof game.numValorFixo != "undefined" ? game.numValorFixo : 0,
          prize: game.numValorFixo * game.numValorPagoJogo,
          selectedPrizes:
            lstPremioFixo && lstPremioFixo[0]
              ? lstPremioFixo[0].vchPremioFixo
              : `${lstPremioExtracao[0].tnyPremioMenor}.${lstPremioExtracao[0].tnyPremioMaior}`,
          raffleTime: extraction ? extraction.chrHorario || "" : "",
          raflleBlockTime: extraction ? extraction.chrHorarioBloqueio || "" : "",
          dateOptions: [dateOption],
          gameTypeId: rifa.intTipoJogo,
          extractionId: extraction ? parseInt(extraction.tnyExtracao) : null,
          game: game,
          id: rifa.Rifa_ID,
          isTotalSalesCalculation: rifa.bitApuracaoTotalVenda,
          startSales: rifa.sdtInicioVenda,
          awardedQuotas: (rifa.arrCotasPremiadas || []).map((quota) => ({
            isAwarded: quota.bitCotaPremiada,
            number: quota.vchNumero,
            value: quota.numValorPremio
          })),
          endSales: rifa.sdtFimVenda,
          result: rifa.vchResultado.trim(),
          isEmphasis: rifa.bitDestaqueWeb,
          rifaModelId: rifa.ModeloRifa_ID,
          minimumAvailableQuotas: rifa.intNumeroMinimoCota || 1,
          buyerRanking: rifa.arrRankingCompradores.map((rank) => ({ name: rank.VchNome, amount: rank.QtdCotasCompradas })),
          winners: raffleWinners
        };
      }
      )
    })).flat().filter(rifa => !!rifa);
  }

  render() {
    const { selectedGame, session, showTicket, ticket, isBicho } = this.state;
    const params = new URL(document.location.href).searchParams;
    const showBackButton = !params.get("page");
    const gameInfo = this.gameInfo(session);

    if (!session) {
      this.getApiInfo();

      return (
        <React.Fragment>
          <div>Carregando...</div>
        </React.Fragment>
      );
    }

    if (!gameInfo || !gameInfo.length) {
      return <React.Fragment>
        <div className="sem-rifas">
          <img src="/assets/sem-rifas.svg" />
          <h4>Nenhuma rifa cadastrada</h4>
          <p>Parece que não cadastraram nenhuma rifa para hoje. Volte mais tarde!</p>
        </div>
      </React.Fragment>
    }

    const rifasConcluidas = this.filterRifasConcluidas(gameInfo, true);

    /**
     * @type {{
     *      title: string,
     *      description: string,
     *      tipo: string,
     *      numberAmount: number,
     *      image: string,
     *      value: number,
     *      prize: string,
     *      raffleTime: string,
     *      dateOptions: string[],
     *  }[]}
     */

    return (
      <React.Fragment>
        {showBackButton ? (
          <button
            onClick={() => this.props.selectConcursoScreen(0)}
            className="back-button-rifa"
          >
            Voltar ao início
          </button>
        ) : null}
        {showTicket && ticket && gameInfo && !this.state.isPix ? (
          <Ticket
            bilhetes={[
              {
                bets: ticket.bets,
                value: ticket.value,
                date: ticket.date,
                extraction: `${moment(ticket.extraction.date).format(
                  "DD/MM/YYYY"
                )} — ${ticket.extraction.name}`,
                prize: ticket.prize,
                venda: ticket.info.number,
                image: selectedGame.image,
                name: selectedGame.title,
              },
            ]}
            onClose={this.hideTicket}
            isBicho={this.state.isBicho}
            preTicket={this.state.isPreTicket}
          />
        ) : null}
        {showTicket && this.state.isPix &&
          <PixTicket isRifa
            ticket={{
              bilhetes: [{
                bets: ticket.bets,
                value: ticket.value,
                date: ticket.date,
                extraction: `${moment(ticket.extraction.date).format(
                  "DD/MM/YYYY"
                )} — ${ticket.extraction.name}`,
                prize: ticket.prize,
                venda: ticket.info.number,
                image: selectedGame.image,
                name: selectedGame.title,
              }],
              ...this.state.ETicket
            }}
            toggleErrorModal={this.props.toggleErrorModal}
            onClose={this.hideTicket}
            isBicho={isBicho}
          />
        }
        {selectedGame == null ? (
          <React.Fragment>
            <Lista
              title=""
              rifas={this.filterRifasConcluidas(gameInfo, false)}
              onSelect={(index) => {
                this.selectGame(index);

                // manter timeout por conta do iphone
                setTimeout(() => {
                  emitIntent("scroll_window", {
                    top: 0
                  });
                }, 100);
              }}
            />
            {rifasConcluidas.length > 0 &&
              <Lista
                isSmallSize={true}
                finishedList={true}
                title="Concluídas"
                rifas={rifasConcluidas}
              />}
          </React.Fragment>
        ) : (<React.Fragment>
          {this.overlay()}
          <JogoRifa
            rifa={selectedGame}
            onReturn={() => this.goBackToList()}
            onConfirm={this.sendBet}
            sendDueBet={this.sendDueBet}
            toggleErrorModal={this.props.toggleErrorModal}
            isBicho={isBicho}
            session={session}
          />
        </React.Fragment>)}
      </React.Fragment>
    );
  }

  overlay() {
    if (this.state.isFetching) {
      return (
        <div className="overlay overlay-rifa">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    return <div></div>;
  }

  selectGame(game) {
    this.props.AnalyticsSetGameType(game.tipo);
    
    const { session } = this.state;
    this.setState({
      ...this.state,
      isBicho: game.numberAmount <= 25,
      selectedGame: game,
    });
  }

  goBackToList() {
    this.setState({
      ...this.state,
      selectedGame: null,
    });
  }

  hideTicket() {
    this.setState({
      ...this.state,
      showTicket: false,
    });
  }

  getUsedNumbers({ date, rifaId }) {
    const dateStr = date || this.state.ticketInfo.extraction.date;
    if (!dateStr) {
      return new Promise();
    }

    const params = {
      url: CONTEST_API + "JBWeb.svc/GetNumerosRifa",
      method: "POST",
      data: {
        Cliente_ID: this.props.user.Cliente_ID,
        Site_ID: forceInt(this.props.user.Site_ID),
        chrSerial: this.props.user.ChrSerial,
        Rifa_ID: rifaId,
        strData: dateStr,
      },
    };

    return new Promise((resolve, reject) => {
      doRequest(params)
        .then((response) => {
          setLoading(true);
          if (response.intCodigoRetorno > 0) {
            this.props.toggleErrorModal("Atenção", response.strErrorMessage);
          } else {
            const disabledNumbers = {};
            response.arrNumeros.forEach((num) => {
              disabledNumbers[num.toString()] = true;
            });

            this.props.setDisabledNumbers(disabledNumbers);

            const newCart = this.props.cart.filter(
              (item) =>
                !disabledNumbers[
                item.number
                  .toString()
                  .padStart(response.arrNumeros.length, 0)
                ]
            );
            newCart.length !== this.props.cart.length &&
              this.props.setCart(newCart);
            setLoading(false);
            resolve(response);
          }
        })
        .catch((err) => {
          setLoading(false);
          reject(err);
        });
    });
  }

  transacaoSemRepeticao({
    cart,
    dateStr,
    gameTypeId,
    extractionId,
    numberLength,
    selectedPrizes,
    prize,
    id,
    strGuidWeb,
    valor,
    isPreTicket,
    isPix,
  }) {
    const { session } = this.state;
    setLoading(true);

    return new Promise((resolve, reject) => {
      this.getUsedNumbers({ date: dateStr, rifaId: id })
        .then((res) => {
          const numerosRegistrados = cart.reduce((arr, item) => {
            const cartNumber = item.number.toString().padStart(numberLength, 0);
            return res.arrNumeros.includes(cartNumber)
              ? arr.concat([cartNumber])
              : arr;
          }, []);

          if (numerosRegistrados.length) {
            return reject(
              "Estes números já foram registrados: " +
              numerosRegistrados.join(", ")
            );
          } else {
            const valorTotal = cart.length * valor;
            const currentDateTime = new Date().toISOString();

            const bets = cart.reduce(
              (previousBets, bet) => [
                ...previousBets,
                ...new Array(bet.amount).fill({
                  sntTipoJogo: gameTypeId,
                  numValor: bet.value,
                  numValorTotal: bet.value,
                  vchNumero: bet.number
                    .toString()
                    .padStart(numberLength, "0"),
                  vchPremio: selectedPrizes,
                }),
              ],
              []
            );

            const extraction =
              (session.arrExtracoesRifa || []).find(
                (ext) =>
                  ext.tnyExtracao.toString() === extractionId.toString()
              ) || {};

            const payload = {
              Sistema_ID: 1,
              Cliente_ID: session.Cliente_ID,
              Site_ID: forceInt(session.Site_ID),
              chrCodigoPonto: this.props.user.ChrCodigoPonto.trim(),
              chrCodigoOperador: this.props.user.ChrCodigoOperador.trim(),
              CID: session.CID,
              chrSerial: this.props.user.ChrSerial,
              Session_ID: session.Session_ID,
              SessionIDLE: session.SessionIDLE,
              Rifa_ID: id,
              strToken: this.props.user.TokenLE,
              intQtdConcursos: 0,
              numValorApostas: valorTotal,
              sntQuantidadeApostas: bets.length,
              valorTotal: valorTotal,
              sdtDataHora: currentDateTime,
              bitPredatado: false,
              strData: "",
              arrApostas: bets,
              strGuidWeb,
              arrExtracaoData: [
                {
                  sdtData: dateStr,
                  tnyExtracao: extractionId,
                },
              ],
            };
            this.props.enviarAposta(payload, (ETicket, isPreTicket, isPix) => {
              if (ETicket.isError) {
                return reject(ETicket.strErrorMessage);
              }

              this.setState({
                ...this.state,
                isPix,
                isPreTicket,
                ETicket: ETicket,
                ticket: {
                  bets: cart,
                  value: valorTotal,
                  date: getDateTime(
                    ETicket.dtmGravacaoBanco
                      ? getTimestamp(ETicket.dtmGravacaoBanco)
                      : Date.now()
                  ),
                  extraction: {
                    name: extraction.vchDescricao || "",
                    date: dateStr,
                  },
                  info: {
                    number: ETicket.arrETicket ? ETicket.arrETicket[0] : null,
                  },
                  prize: R$(prize),
                },
                showTicket: true,
              });

              resolve(ETicket);
              setLoading(false);

            }, isPreTicket, isPix, (title, message) => {
              this.props.toggleErrorModal(title, message);
              reject(message);
            });
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(true);
          reject("Não foi possivel completar transação.");
        });
    });
  }

  validateExtractionTime(date, extraction) {
    const currentDateTime = new Date();
    if (!extraction) {
      return true;
    } else {
      const extractionTime = extraction.chrHorarioBloqueio;
      const extractionDate = new Date(date.split(' ')[0]+" "+extractionTime);

      extractionDate.setMinutes(extractionDate.getMinutes() - 5);

      if (extractionDate <= currentDateTime) {
        return true;
      }
    }
    return false;
  }

  sendDueBet({
    rifaId,
    date,
    intQtdNumeros,
    extractionId,
    sntTipoJogoSistema,
    sntTipoJogo,
    valorTotal,
    valor,
    numberLength,
    strGuidWeb,
    isPreTicket,
    isPix,
    clearCartFn
  }) {
    setLoading(true);
    const { session } = this.state;

    this.setState({
      isFetching: true
    });

    const promise = new Promise((resolve, reject) => {
      const currentDateTime = new Date();

      const extraction =
        (session.arrExtracoesRifa || []).find(
          (extraction) =>
            extraction.tnyExtracao.toString() === extractionId.toString()
        ) || {};

      // if (this.validateExtractionTime(date, extraction)) {
      //   this.props.toggleErrorModal('Extração Encerrada', 'Não existe mais extração disponivel para essa aposta.');
      //   return reject('Não existe mais extração disponivel para essa aposta.');
      // }

      const payload = {
        Sistema_ID: 1,
        Cliente_ID: session.Cliente_ID,
        Site_ID: forceInt(session.Site_ID),
        chrCodigoPonto: this.props.user.ChrCodigoPonto.trim(),
        chrCodigoOperador: this.props.user.ChrCodigoOperador.trim(),
        CID: session.CID,
        chrSerial: this.props.user.ChrSerial,
        Session_ID: session.Session_ID,
        SessionIDLE: session.SessionIDLE,
        Rifa_ID: rifaId,
        strToken: this.props.user.TokenLE,
        intQtdConcursos: 0,
        numValorApostas: valorTotal,
        sntQuantidadeApostas: intQtdNumeros,
        valorTotal: valorTotal,
        sdtDataHora: currentDateTime.toISOString(),
        bitPredatado: false,
        strData: "",
        arrExtracaoData: [
          {
            sdtData: date,
            tnyExtracao: extractionId,
          },
        ],
      };

      this.props.enviarAposta(payload, (ETicket, isPreTicket, isPix) => {
        if (!ETicket) {
          return reject(ETicket);
        }

        this.setState({
          ...this.state,
          isPix,
          isPreTicket,
          ETicket: ETicket,
          ticket: {
            bets: [],
            value: valorTotal,
            date: getDateTime(
              ETicket.dtmGravacaoBanco
                ? getTimestamp(ETicket.dtmGravacaoBanco)
                : Date.now()
            ),
            extraction: {
              name: extraction.vchDescricao || "",
              date,
            },
            info: {
              number: ETicket.arrETicket ? ETicket.arrETicket[0] : null,
            },
          },
          showTicket: true,
        });
        this.props.AnalyticsSetFinishPurchase(valorTotal);
        setLoading(false);
        if(clearCartFn) clearCartFn();
        resolve();
      }, isPreTicket, isPix, (title, message) => {
        this.props.toggleErrorModal(title, message);
        reject(message);
      });
    });

    promise.finally(() => {
      this.setState({
        isFetching: false
      });
    });

    return promise;
  }

  sendBet(payload, isPreTicket, isPix) {
    this.setState({
      isFetching: true
    });

    const promise = new Promise((resolve, reject) => {
      const { session } = this.state;

      const extraction =
        (session.arrExtracoesRifa || []).find(
          (extraction) =>
            extraction.tnyExtracao.toString() === payload.extractionId.toString()
        ) || {};

      // if (this.validateExtractionTime(payload.dateStr, extraction)) {
      //   this.props.toggleErrorModal('Extração Encerrada', 'Não existe mais extração disponivel para essa aposta.');
      //   return reject('Não existe mais extração disponivel para essa aposta.');
      // }

      if (payload.tipo === "com-validacao") {
        this.transacaoSemRepeticao(payload, isPreTicket, isPix)
          .then((res) => {
            this.props.AnalyticsSetFinishPurchase(payload.valor);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        this.transacaoComRepeticao(payload, isPreTicket, isPix)
          .then((res) => {
            this.props.AnalyticsSetFinishPurchase(payload.valor);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });

    promise.finally(() => {
      this.setState({
        isFetching: false
      });
    });

    return promise;
  }

  /**
   * @param cart {{
   *  number: number,
   *  value: number,
   *  amount: number
   * }[]},
   * @param date {string}
   * @param raffleInfo {{
   *  gameTypeId: number,
   *  extractionId: number,
   *  numberLength: number,
   *  prize: string
   * }}
   */
  transacaoComRepeticao({
    cart,
    dateStr: date,
    gameTypeId,
    extractionId,
    numberLength,
    selectedPrizes,
    prize,
    id,
    isPix = false,
    isPreTicket = false,
  }) {
    const { session } = this.state;

    const bets = cart.reduce(
      (previousBets, bet) => [
        ...previousBets,
        ...new Array(bet.amount).fill({
          sntTipoJogo: gameTypeId,
          numValor: bet.value,
          numValorTotal: bet.value,
          vchNumero: bet.number.toString().padStart(numberLength, "0"),
          vchPremio: selectedPrizes,
        }),
      ],
      []
    );

    const totalValue = cart.reduce(
      (sum, bet) => sum + bet.value * bet.amount,
      0
    );

    return new Promise((resolve, reject) => {
      const currentDateTime = new Date().toISOString();
      const extraction =
        (session.arrExtracoesRifa || []).find(
          (extraction) =>
            extraction.tnyExtracao.toString() === extractionId.toString()
        ) || {};

      const payload = {
        Sistema_ID: 1,
        Cliente_ID: session.Cliente_ID,
        Site_ID: forceInt(session.Site_ID),
        chrCodigoPonto: this.props.user.ChrCodigoPonto.trim(),
        chrCodigoOperador: this.props.user.ChrCodigoOperador.trim(),
        CID: session.CID,
        chrSerial: this.props.user.ChrSerial,
        Session_ID: session.Session_ID,
        SessionIDLE: session.SessionIDLE,
        Rifa_ID: id,
        strToken: this.props.user.TokenLE,
        intQtdConcursos: 0,
        numValorApostas: totalValue,
        sntQuantidadeApostas: bets.length,
        valorTotal: totalValue,
        sdtDataHora: currentDateTime,
        bitPredatado: false,
        strData: "",
        arrApostas: bets,
        arrExtracaoData: [
          {
            sdtData: date,
            tnyExtracao: extractionId,
          },
        ],
      };

      this.props.enviarAposta(payload, (ETicket, isPreTicket, isPix) => {

        this.setState({
          ...this.state,
          isPix,
          isPreTicket,
          ETicket: ETicket,
          ticket: {
            bets: cart,
            value: totalValue,
            date: getDateTime(Date.now()),
            extraction: {
              name: extraction.vchDescricao || "",
              date,
            },
            info: {
              number: ETicket.arrETicket ? ETicket.arrETicket[0] : null,
            },
            prize: R$(prize),
          },
          showTicket: true,
        });

        resolve();
      }, isPreTicket, isPix, (title, message) => {
        this.props.toggleErrorModal(title, message);
        reject(message);
      });
    });
  }

  getApiInfo() {
    const params = new URL(document.location.href).searchParams;
    let siteId = params.get("siteId");
    let clientId = params.get("clientId");
    let ponto = params.get("ponto");
    let operador = params.get("operador");
    let token = params.get("token");
    let userId = params.get("userId");
    let sessionId = params.get("sessionId");

    newSession(clientId, "", token, sessionId, ponto, operador, null, siteId).then(
      ({ payload }) => {
        this.setState({
          ...this.state,
          session: payload,
        });
      }
    );
  }
}

const mapStateToProps = (state) => ({
  selectedNumbers: state.rifa.selectedNumbers,
  user: state.usuario.objUser,
  cart: state.rifa.cart,
  loading: state.rifa.loading,
  strGuidWeb: state.rifa.strGuidWeb,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectConcursoScreen,
      setCart,
      setDisabledNumbers,
      setLoading,
      setGUID,
      enviarAposta,
      AnalyticsSetGameType,
      AnalyticsSetFinishPurchase,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Rifa);



// WEBPACK FOOTER //
// ./src/rifa/rifa.jsx